<template>
  <div>
    <h1>Matriculas | <small>{{ user.email }}</small></h1>
    <v-divider class="my-5"></v-divider>
    <v-simple-table
      fixed-header
    >
      <template v-slot:default>
        <thead>
        <tr>
          <th class="text-left">
            Curso
          </th>
          <th class="text-left">
            Tipo
          </th>
          <th class="text-left">
            Estado
          </th>
          <th class="text-left">
          </th>
        </tr>
        </thead>
        <tbody>
        <tr
          v-for="enrolment in enrolments"
          :key="enrolment.id"
        >
          <td>{{ enrolment.course.name }} <small>{{ enrolment.course.code }}</small></td>
          <td>{{ getType(enrolment) }}</td>
          <td>{{ getState(enrolment) }} <small>{{ getAccessLimit(enrolment) }}</small></td>
          <td>
            <v-btn text :to="{ name: 'EditEnrolment', params: { userId: user.id, enrolmentId: enrolment.id }}" color="success">
              <v-icon left>mdi-pencil</v-icon>
              Editar
            </v-btn>
            <v-btn text @click="removeEnrolment(enrolment)" color="error">
              <v-icon left>mdi-delete</v-icon>
              Remover
            </v-btn>
          </td>
        </tr>
        </tbody>
      </template>
    </v-simple-table>
    <v-alert v-if="!enrolments.length" type="info">
      Nenhuma matrícula encontrada.
    </v-alert>
    <v-btn
      :to="{ name: 'CreateEnrolment', params: { userId }}"
      color="success"
      fab
      x-large
      right
      bottom
      fixed
    >
      <v-icon>mdi-plus</v-icon>
    </v-btn>
    <v-snackbar v-model="snackbar">
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import AdminEnrolmentService from '@/services/admin-enrolment/admin-enrolment.service';
import AdminUserService from '@/services/admin-user/admin-user.service';
import User from '@/models/user';

const userService = new AdminUserService();
const enrolmentService = new AdminEnrolmentService();

export default {
  name: 'EnrolmentsUser',
  data: () => ({
    userId: null,
    user: new User(),
    enrolments: [],
    snackbar: false,
    snackbarText: '',
  }),
  mounted() {
    this.userId = this.$route.params?.userId ?? null;

    if (this.userId === null) {
      this.$router.push('/');
      return;
    }

    userService.get(this.userId)
      .then((response) => this.user = response.data)
      .catch(console.error);

    this.updateEnrolments();
  },
  methods: {
    showSnack(text) {
      this.snackbar = true;
      this.snackbarText = text;
    },
    updateEnrolments() {
      userService.enrolments(this.userId)
        .then((response) => this.enrolments = response.data)
        .catch((err) => {
          this.showSnack(err?.response?.data?.message ?? 'Falha ao resgatar matriculas');
        });
    },
    removeEnrolment(enrolment) {
      enrolmentService.remove(enrolment.id)
        .then((response) => this.showSnack(response.data.message))
        .catch((err) => {
          this.showSnack(err?.response?.data?.message ?? 'Falha ao apagar matricula');
        })
        .finally(() => this.updateEnrolments());
    },
    getType(enrolment) {
      switch (enrolment.type) {
        case 'unlimited':
          return 'Ilimitado';
        case 'regular':
          return 'Normal';
        default:
          return 'Desconhecido';
      }
    },
    getState(enrolment) {
      switch (enrolment.state) {
        case 'provisioned':
          return 'Provisionado';
        case 'expired':
          return 'Expirado';
        case 'to_provision':
          return 'Aguardando provisionamento';
        case 'not_started':
          return 'Aluno não iniciou o curso';
        default:
          return 'Desconhecido';
      }
    },
    getAccessLimit(enrolment) {
      if (!enrolment.accessLimit || enrolment.type === 'unlimited') {
        return '';
      }

      const date = new Date(enrolment.accessLimit);

      return `${date.getDate()}/${date.getMonth()+1}/${date.getFullYear()}`;
    },
  }
};
</script>

<style scoped>

</style>
